import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/styles";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useApolloClient } from "@apollo/client";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import SnackbarContext from "../../../containers/CustomSnackbar/SnackbarContext";
import updateUserMutation from "../../../graphql/user/mutation/update-user";
import getComapniesQuery from "../../../graphql/companies/query/companies";

const R = require("ramda");

const styles = () => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: 8,
    marginRight: 8,
    width: 200,
  },
  selectInput: {
    marginLeft: 8,
    marginRight: 8,
    marginTop: 16,
    width: 200,
    borderWidth: 1,
    borderColor: "black",
  },
  checkbox: {
    marginLeft: 8,
    marginRight: 8,
    marginTop: 16,
    width: 400,
  },
  test: {
    border: "1px solid #e0e0e0",
  },
});

function UserDialog(props) {
  const { classes, closeMenu, user, refetch } = props;
  const client = useApolloClient();
  console.log(user);
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
    closeMenu();
  }

  function handleClose() {
    setOpen(false);
  }

  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    steps: 0,
    coins: 0,
    password: "",
    company: { _id: "" },
    verified: "",
    roles: ["user"],
    companies: [],
    idNumber: "",
  });

  useEffect(() => {
    getCompanies();

    if (!props.user) return;
    const firstName = R.pathOr("", ["firstName"])(props.user);
    const lastName = R.pathOr("", ["lastName"])(props.user);
    const coins = R.pathOr("", ["coins"])(props.user);
    const steps = R.pathOr("", ["steps"])(props.user);
    const email = R.pathOr("", ["email"])(props.user);
    const phone = R.pathOr("", ["phone"])(props.user);
    const company = R.pathOr({ _id: "" }, ["company"])(props.user);
    const verified = R.pathOr("", ["verified"])(props.user);
    const roles = R.pathOr(["user"], ["roles"])(props.user);
    const idNumber = R.pathOr("", ["idNumber"])(props.user);
    setValues({
      ...values,
      firstName,
      lastName,
      coins,
      steps,
      email,
      phone,
      company,
      verified,
      roles,
      idNumber,
    });
  }, [props.user]);

  const isMounted = React.useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const getCompanies = () => {
    client
      .query({
        query: getComapniesQuery,
      })
      .then(({ data }) => {
        const { companies } = data;
        if (!companies || !isMounted.current) return;
        const firstName = R.pathOr("", ["firstName"])(user);
        const lastName = R.pathOr("", ["lastName"])(user);
        const coins = R.pathOr("", ["coins"])(user);
        const steps = R.pathOr("", ["steps"])(user);
        const email = R.pathOr("", ["email"])(user);
        const phone = R.pathOr("", ["phone"])(user);
        const company = R.pathOr({ _id: "" }, ["company"])(user);
        const verified = R.pathOr("", ["verified"])(user);
        const roles = R.pathOr(["user"], ["roles"])(user);
        const idNumber = R.pathOr("", ["idNumber"])(user);
        setValues((prev) => {
          return {
            ...prev,
            firstName,
            lastName,
            steps,
            coins,
            email,
            phone,
            company,
            verified,
            roles,
            companies,
            idNumber,
          };
        });

        return null;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  const handleCompanyChange = (name) => (event) => {
    // Find the full company object
    const selectedCompany = values.companies.find(
      (c) => c._id === event.target.value,
    );
    setValues({
      ...values,
      company: selectedCompany || { _id: event.target.value },
    });
  };

  const handleRoleChange = (role) => {
    const currentRoles = values.roles;
    let newRoles;
    if (currentRoles.includes(role)) {
      newRoles = currentRoles.filter((item) => item !== role);
    } else {
      newRoles = currentRoles;
      newRoles.push(role);
    }
    setValues({ ...values, roles: newRoles });
  };

  const inputLabel = React.useRef(null);

  const { _id } = user;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const getUserCompany = () => {
    const userCompany = values.companies.find(
      (company) => company._id === values.company._id,
    );
    return userCompany;
  };

  const company = getUserCompany();

  return (
    <>
      <MenuItem onClick={() => handleClickOpen()}>
        <Typography variant="body1" color="textSecondary">
          Edit
        </Typography>
      </MenuItem>

      <Dialog
        fullScreen={fullScreen}
        maxWidth="sm"
        fullWidth
        scroll="body"
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="form-dialog-title">Edit User</DialogTitle>
        <DialogContent>
          <form className={classes.container} noValidate autoComplete="off">
            <TextField
              id="firstName"
              label="First Name"
              className={classes.textField}
              value={values.firstName}
              onChange={handleChange("firstName")}
              margin="normal"
              variant="outlined"
              fullWidth
            />
            <TextField
              id="lastName"
              label="Last Name"
              className={classes.textField}
              value={values.lastName}
              onChange={handleChange("lastName")}
              margin="normal"
              variant="outlined"
              fullWidth
            />
            <TextField
              id="steps"
              label="user steps"
              className={classes.textField}
              value={values.steps}
              onChange={handleChange("steps")}
              margin="normal"
              type="number"
              variant="outlined"
              fullWidth
            />
            <TextField
              id="coins"
              label="user coins"
              className={classes.textField}
              value={values.coins}
              onChange={handleChange("coins")}
              margin="normal"
              type="number"
              variant="outlined"
              fullWidth
            />
            <TextField
              id="email"
              label="Email"
              className={classes.textField}
              value={values.email}
              onChange={handleChange("email")}
              margin="normal"
              variant="outlined"
              fullWidth
            />
            <TextField
              id="phone"
              label="Phone (0XXXXXXXXX)"
              className={classes.textField}
              value={values.phone}
              onChange={handleChange("phone")}
              margin="normal"
              variant="outlined"
              fullWidth
              inputProps={{ maxLength: 10 }}
              placeholder="0501234567"
            />
            <TextField
              id="password"
              label="New Password"
              className={classes.textField}
              value={values.password}
              onChange={handleChange("password")}
              margin="normal"
              variant="outlined"
              fullWidth
            />
            {/* BUG 4: ID field always visible, not gated by isIdRequired */}
            <TextField
              id="idNumber"
              label="National ID"
              className={classes.textField}
              value={values.idNumber}
              onChange={handleChange("idNumber")}
              margin="normal"
              variant="outlined"
              fullWidth
              inputProps={{ maxLength: 10 }}
              placeholder="123456789"
            />
            <FormControl variant="outlined" className={classes.selectInput}>
              <InputLabel ref={inputLabel} htmlFor="outlined-age-simple">
                Company
              </InputLabel>
              <Select
                MenuProps={{ classes: { list: classes.test } }}
                value={values?.company?._id}
                onChange={handleCompanyChange("company")}
                input={
                  <OutlinedInput
                    labelWidth={60}
                    name="company"
                    id="outlined-age-simple"
                  />
                }
              >
                {values?.companies?.length > 0 ? (
                  Array.from(values.companies)
                    .sort((compA, compB) =>
                      compA.name.localeCompare(compB.name),
                    )
                    .map((company) => (
                      <MenuItem key={company._id} value={company._id}>
                        {company.name}
                      </MenuItem>
                    ))
                ) : (
                  <MenuItem key={1} value="">
                    No Available Companies
                  </MenuItem>
                )}
                {values?.companies?.length > 0 && (
                  <MenuItem key="none" value="none">
                    No Company
                  </MenuItem>
                )}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.selectInput}>
              <InputLabel ref={inputLabel} htmlFor="outlined-age-simple">
                Verified
              </InputLabel>
              <Select
                MenuProps={{ classes: { list: classes.test } }}
                value={values.verified}
                onChange={handleChange("verified")}
                input={
                  <OutlinedInput
                    labelWidth={50}
                    name="verified"
                    id="outlined-age-simple"
                  />
                }
              >
                <MenuItem key={1} value>
                  True
                </MenuItem>
                <MenuItem key={2} value={false}>
                  False
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl component="fieldset" className={classes.checkbox}>
              <FormLabel component="legend">Roles</FormLabel>
              <FormGroup>
                {/* <FormControlLabel */}
                {/*    control={<Checkbox color="primary" checked={values.roles.includes('user')} */}
                {/*                       onChange={() => handleRoleChange('user')} value="user"/>} */}
                {/*    label="User" */}
                {/* /> */}
                {/* <FormControlLabel */}
                {/*    control={<Checkbox color="primary" checked={values.roles.includes('trainer')} */}
                {/*                       onChange={() => handleRoleChange('trainer')} value="trainer"/>} */}
                {/*    label="Trainer" */}
                {/* /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={values.roles.includes("admin")}
                      onChange={() => handleRoleChange("admin")}
                      value="admin"
                    />
                  }
                  label="Admin"
                />
              </FormGroup>
              <FormHelperText>
                Notice: Users marked as 'admin' or 'trainer' can make changes to
                events, promotions and user data.
              </FormHelperText>
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <SnackbarContext.Consumer>
            {(value) => (
              <Button
                onClick={() => {
                  const {
                    firstName,
                    lastName,
                    email,
                    phone,
                    steps,
                    coins,
                    company,
                    roles,
                    verified,
                    password,
                    idNumber,
                  } = values;
                  const parsedSteps = parseInt(steps);
                  const parsedCoins = parseInt(coins);
                  const variables = {
                    _id,
                    firstName,
                    lastName,
                    email,
                    phone,
                    company: company && company._id !== "" ? company._id : null,
                    roles,
                    verified,
                  };
                  // Only include optional fields when they have valid values
                  // to avoid overwriting existing data with empty strings or NaN
                  if (password) variables.password = password;
                  if (idNumber) variables.idNumber = idNumber;
                  if (!isNaN(parsedSteps)) variables.steps = parsedSteps;
                  if (!isNaN(parsedCoins)) variables.coins = parsedCoins;
                  console.log(variables);

                  // BUG 4: Always require ID number (not gated by company setting)
                  if (!idNumber || !idNumber.trim()) {
                    return value.openSnackbar(
                      "error",
                      "National ID is required.",
                    );
                  }
                  // BUG 4: Validate national ID format (7-10 digits)
                  const idTrimmed = String(idNumber).replace(/\.0$/, '').trim();
                  if (!/^\d{7,10}$/.test(idTrimmed)) {
                    return value.openSnackbar(
                      "error",
                      "National ID must be between 7 and 10 digits.",
                    );
                  }
                  if (idTrimmed === '123456789') {
                    return value.openSnackbar(
                      "error",
                      "Invalid national ID number.",
                    );
                  }
                  // BUG 3: Validate phone format (0XXXXXXXXX)
                  if (phone) {
                    const normalizedPhone = phone.replace(/^\+972/, '0').replace(/^972/, '0').replace(/\.0$/, '').trim();
                    if (!/^0\d{9}$/.test(normalizedPhone)) {
                      return value.openSnackbar(
                        "error",
                        "Phone must be 10 digits in the format 0XXXXXXXXX (e.g. 0501234567).",
                      );
                    }
                  }
                  return firstName === "" ||
                    lastName === "" ||
                    email === ""
                    ? value.openSnackbar(
                        "error",
                        "Please make sure first name, last name, and email are not empty.",
                      )
                    : client
                        .mutate({
                          mutation: updateUserMutation,
                          variables,
                        })
                        .then((data) => {
                          console.log(data);
                          handleClose();
                          value.openSnackbar(
                            "success",
                            "User information updated successfully",
                          );
                          if (refetch) refetch();
                        })
                        .catch((error) => {
                          value.openSnackbar(
                            "error",
                            `${!!error && error.message && error.message}`,
                          );
                          console.log(error);
                        });
                }}
                color="primary"
              >
                OK
              </Button>
            )}
          </SnackbarContext.Consumer>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default withStyles(styles)(UserDialog);
